// src/services/sales/QuotationHistoryService.ts

import { quotationHistoryApi } from '../../api';

const QuotationHistoryService = {

    /**
     * 📚 Obtener historial filtrado
     * POST /api/quotations/history/search
     */
    search: async (
        filters: any,
        page = 0,
        size = 10,
        sort = 'quotationDate,desc'
    ) => {

        const response =
            await quotationHistoryApi.addCustom(
                `/search?page=${page}&size=${size}&sort=${sort}`,
                filters
            );

        return response.data;

    },

};

export default QuotationHistoryService;